import { InjectionToken } from '@angular/core';

/**
 * Lets Angular components tell the Express SSR server how the HTTP response should look.
 * The server provides a fresh object per request (see projects/shop/server.ts); in the
 * browser nothing provides it, so it must always be injected with { optional: true }.
 */
export interface SsrResponseState {
  /** HTTP status to send instead of 200 (e.g. 404 for unknown pages). */
  status?: number;
  /** Send `X-Robots-Tag: noindex, nofollow`. */
  noindex?: boolean;
  /** Answer with a 301 to this path instead of rendering the page. */
  redirect?: string;
  /** Country the API resolved for this visitor (X-Resolved-Country); the SSR cache is split by it. */
  country?: string;
}

export const SSR_RESPONSE = new InjectionToken<SsrResponseState>('SSR_RESPONSE');
